import React from "react";
import { usePayPageVM } from "./PayPageViewModel";
import PayPageView from "./PayPageView";

interface Props {
  tag: string;
}

const PayPage: React.FC<Props> = ({ tag }) => {
  const vm = usePayPageVM(tag);

  return <PayPageView state={vm.state} actions={vm.actions} refs={vm.refs} />;
};

export default PayPage;